<template>
    <div class="content">
        <img src="../../assets/img/rz_01.png" alt="">
        <img src="../../assets/img/rz_02.png" alt="">
        <img src="../../assets/img/rz_03.png" alt="">
        <img src="../../assets/img/rz_04.png" alt="">
        <img src="../../assets/img/rz_05.png" alt="">
    </div>
</template>

<script>
    export default {
        created () {
            document.title = "选择商家主体"
        },
    }
</script>

<style lang="scss" scoped>
.content{
    width: 100%;
}
.content img{
    width: 100%;
    display: block;
}
</style>